import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { ArchivedStatService } from '@mailer/services/StatService';

export const general = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => ArchivedStatService.getGeneral(params)
    }
  },
  true
);
